<template>
  <div class="mydevice-bd">
    <div class="product-wrap">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item v-if="orgBy==='serviceCompany'">
            <el-button type="primary" @click="onRenter()">
              <i class="icon icon-add"></i>
              {{$t('Common.com_add')}}
            </el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('crm_partner-renter.zlfmc')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          ref="tb1"
          v-loading="isLoading"
          :size="allTableSize"
          :data="renterList"
          :tableCode='tableCode'
          height="100%"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
          @column="setColumn"
          :filterArr="tableCode==='crm_renter'?[]:['partnerType']"
          :slots="['partnerName', 'action']"
        >
        <template v-slot:partnerName="scope">
          <div class="cell-link"  @click="jump('/customer/renterDetail',{ parentPath: $route.fullPath,renterId: scope.row.partnerId, bizType: scope.row.partnerType })">{{ scope.row.partnerName }}</div>
        </template>
        <template v-slot:action="scope">
          <span></span>
          <el-button type="text" size="mini" @click="onEditRenter(scope.row)" >{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState === 1">{{ $t('Common.com_disable') }}</el-button>
          <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState === 0">{{ $t('Common.com_enable') }}</el-button>

          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 修改密码 -->
              <el-dropdown-item @click.native="editPassword(scope.row)">
                {{$t('crm_partner-renter.xiu_gai_mi_ma')}}
              </el-dropdown-item>
              <!-- 更换管理员 -->
              <el-dropdown-item  @click.native="editAdministrators(scope.row)">
                {{$t('crm_partner-renter.ghgly')}}
              </el-dropdown-item>
              <!-- 审核租赁方-->
              <!--  -->
              <el-dropdown-item
                v-if="scope.row.approvalState === 0 && $store.state.userInfo.bizType === 'HQ'"
                @click.native="jump('/customer/renter/examine', { parentPath:`${$route.path}?companyId=${partnerId}&bizType=${partnerType}&partnerOrgId=${partnerOrgId}&tab=renter`, renterId: scope.row.partnerId })"
              >
                {{$t('crm_partner-renter.shen_he_zu_lin_fang')}}
              </el-dropdown-item>
              <!-- 实名认证审批 -->
              <!--  -->
              <el-dropdown-item
                v-if="scope.row.realNameState === 1 && scope.row.verifyMethod === 3 && $store.state.userInfo.bizType === 'HQ'"
                @click.native="jump('/customer/renter/verified', { parentPath:`${$route.path}?companyId=${partnerId}&bizType=${partnerType}&partnerOrgId=${partnerOrgId}&tab=renter`, companyId: scope.row.partnerId })"
              >
                {{$t('crm_partner-renter.smrzsp')}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table>
      </div>
      <div class="table-page">
        <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
      </div>
    </div>
    <!-- 商品详情弹窗 -->
    <!-- <product-detail-dialog v-model="dialogVisible" :productId="productId" :model="dialogModel"></product-detail-dialog> -->
    <!-- <waitdevice></waitdevice> -->
     <!-- 跟换管理员-->
     <partner-administrators-dialog v-if="dialogVisible" :model="dialogModel" :data="dialogData" @success="getRenterList" @close="dialogVisible = false"></partner-administrators-dialog>
    <!-- 修改管理员密码 -->
    <partner-password-dialog v-if="dialogVisible1" :model="dialogModel1" :data="dialogData1" @success="getRenterList" @close="dialogVisible1 = false"></partner-password-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import waitdevice from './waitdevice.vue';
import partnerPasswordDialog from '@/pages/crm/components/partnerCommon/partner_password_dialog.vue';
import partnerAdministratorsDialog from '@/pages/crm/components/partnerCommon/partner_administrators_dialog.vue';

export default {
  props: {
    'partnerOrgId': String,
    'partnerId': String,
    'partnerType': String,
    'tableCode': String,
    orgBy: {
      type: String,
      default: ''
    },
  },
  components: { partnerPasswordDialog, partnerAdministratorsDialog },
  data() {
    return {
      // tableCode: 'service_hire',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerType: '',
        partnerId: '',
        businessLicense: ''
      },
      // 更换管理员
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 修改密码
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      // formSearch: {
      //   search: '',
      //   orderType: '',
      //   orderBy: '',
      //   pageSize: 50,
      //   pageNum: 1,
      //   bizType: 'factory', // 总部service
      //   partnerId: '',
      //   businessLicense: ''
      // },
      renterList: [],
      totalRows: null
    };
  },
  mounted() {
    this.formSearch.orgId = this.partnerOrgId;
    // 租赁方ID
    this.formSearch.partnerId = this.partnerId;
    this.formSearch.partnerType = this.partnerType;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getRenter();
  },
  methods: {
    // 获取我的设备列表
    getRenter: function () {
      this.isLoading = true;
      this.$getJSON(apis.partnerCustomerPage, this.formSearch).then((res) => {
        this.isLoading = false;
        const list = res.data.list;
        this.renterList = list;
        this.totalRows = res.data.total;
      });
    },
    onRenter() {
      this.clearTagByKeep('renter');
      if (this.orgBy === 'serviceCompany') {
        const companyId = this.getJump('companyId');
        this.jump('/redirect/distributor/serviceCompany/renterAdd', { orgId: this.partnerOrgId, parentPath: `/distributor/serviceCompany/detail?tab=renter&companyId=${companyId}` });
      }
    },
    onEditRenter(row) {
      this.jump('/redirect/customer/renter/edit', { parentPath: `${this.$route.path}?companyId=${this.partnerId}&bizType=${this.partnerType}&partnerOrgId=${this.partnerOrgId}&tab=renter`, renterId: row.partnerId, partnerOrgId: row.partnerOrgId });
    },
    // 更换管理员
    editAdministrators: function (row) {
      this.dialogData = row;
      this.dialogModel.title = this.$t('crm_partner-renter.ghgly');
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
    },
    // 修改密码
    editPassword: function (row) {
      this.dialogData1 = row;
      this.dialogModel1.title = this.$t('crm_partner-renter.xgglymm');
      this.dialogModel1.type = 'edit';
      this.dialogVisible1 = true;
    },
    // 禁用启用
    updateState: function ({ partnerState, partnerId }) {
      let tips;
      if (partnerState === 1) {
        tips = this.$t('crm_partner-renter.nqdyjydqzlfm');
        partnerState = 0;
      } else {
        tips = this.$t('crm_partner-renter.nqdyqydqzlfm');
        partnerState = 1;
      }
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.partnerUpdateState, {
            partnerState,
            partnerId,
          }).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getRenter();
            }
          });
        })
        .catch(() => {});
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRenter();
    },

  }
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 220px;
    display: flex;
    .g2-p1 {
      width: 500px;
      height: 220px;
    }
    .g2-p2 {
      width: 460px;
      height: 200px;
      .g2-legend {
        height: 120px !important;
        width: 800px !important;
        max-width: 800px !important;
      }
      .g2-legend-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100%;
      }
      .g2-legend-list-item {
        width: 120px;
      }
    }
  }
  .product-wrap {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
